import { imageAssetUrl } from "@/utils/url";

export function FamilyOverviewEmpty() {
  return (
    <div className="flex flex-row flex-1 bg-card border border-border rounded-lg items-center">
      <div className="flex items-center flex-1 justify-center gap-6">
        <div className="flex flex-col items-start w-100 shrink-0">
          <span className="text-xl font-semibold">
            No holdings for this Family
          </span>
          <span className="mt-2 text-muted-foreground max-w-100">
            Create transactions or fetch external holdings for clients from this
            Family to view them here.
          </span>
        </div>
        <div className="flex justify-center items-center h-105 shrink-0">
          <img
            className="h-full aspect-auto"
            src={imageAssetUrl("/family-empty.png")}
          />
        </div>
      </div>
    </div>
  );
}
